/**
 * @param {string} country
 * @returns {string|undefined}
 */
function currentTime (country = 'se') {
  const timeZone = {
    se: 'Europe/Stockholm',
    no: 'Europe/Oslo',
    fi: 'Europe/Helsinki'
  }[country]

  return new Date().toLocaleString('sv-SE', { timeZone })
}

module.exports = { currentTime }
